<template>
	<div class="stock-warning">
		<strong>You've selected more than we currently have on the website.</strong>
		<p>But don't worry - we may still be able to assist! Call us on <a href="tel:0800872011">0800 87 2011</a> or <a href="#EnquiryForm">click here</a> to send an enquiry.</p>
	</div>
</template>
